import { render, staticRenderFns } from "./LayoutClient.vue?vue&type=template&id=346b342f"
import script from "./LayoutClient.vue?vue&type=script&lang=js"
export * from "./LayoutClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports